<template>
  <div class="card card-liste-faces">
    <div class="card-content">
      <div>
        <a class="is-pulled-right" @click="$parent.close()">
          <b-icon icon="close"></b-icon>
        </a>
        <div class="columns">
          <div class="column">
            <h1 class="subtitle">Réseau : {{reseau.libelle}}</h1>
          </div>
        </div>
        <b-tabs type="is-toggle">
          <b-tab-item label="Carte">
            <div class="map-modal" v-if="markers.length">
              <gmap-map
                :center="{ lat: reseau.latitude, lng: reseau.longitude }"
                :zoom="12"
                class="googleMap"
                ref="map">
                <gmap-marker :key="m.num"
                             v-for="(m) in markers"
                             :position="m.position"
                             :clickable="m.clickable"
                             :draggable="false"
                             :icon="m.icon"
                             @click="selecMarker(m)">
                </gmap-marker>
              </gmap-map>
            </div>
          </b-tab-item>
          <b-tab-item label="Liste">
            <app-liste
              :reseau="reseau"
              :disabled="disabled"
              :generateMarker="generateMarker"/>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';
import Liste from './listeFacesReseau';

export default {
  name: 'index',
  props: ['reseau', 'disabled'],
  components: {
    appListe: Liste,
  },
  data() {
    return {
      markers: [],
    };
  },
  computed: {
  },
  methods: {
    generateMarker() {
      this.reseau.listeFaces.forEach((face) => {
        if (face.latitude !== 0 && face.longitude !== 0) {
          if (face.selected) {
            face.color = niveauDispo.COULEUR_SELECTION;
          } else if (this.reseau.couleur) {
            face.color = this.reseau.couleur;
          }
        }
      });
      this.markers = fromTypeToMarkers('facesFromVentesReseaux', this.reseau.listeFaces);
    },
    selecMarker(marker) {
      if (!this.disabled) {
        marker.selected = !marker.selected;
        marker.faces.forEach((el) => {
          const faceSelected = this.reseau.listeFaces.find((face) => {
            return el.facCode === face.facCode;
          });
          faceSelected.selected = marker.selected;
        });
        this.generateMarker();
      }
    },
  },
  mounted() {
    this.generateMarker();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxNumerique/recherche/consultation/carte_reseau_num.vue